import { Component, inject, Input, OnInit } from '@angular/core';
import { BaseButtonComponent } from '../base-button';
import { Action, ActionType } from 'src/app/models/action';
import { EditListFacade } from '../../../edit-list/state/edit-list.facade';

@Component({
  selector: 'app-add-to-list-button',
  templateUrl: './add-to-list-button.component.html',
  styleUrls: ['./add-to-list-button.component.scss', '../base-button.scss'],
})
export class AddToListButtonComponent extends BaseButtonComponent implements OnInit {
  private readonly editListFacade = inject(EditListFacade);

  @Input()
  isMoreOption: string;

  @Input()
  recordId: string;

  textDirection: string;

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
    if (this.recordId != null) {
      this.record = { id: this.recordId };
    }
  }

  addToList(listId: number) {
    if (this.userService.isInList(listId, this.record.id)) {
      this.toastService.showToast('messages.lists.duped', 'info');
    }

    this.apiService.addToList(this.userService.getUserId(), listId, this.record.id).subscribe((item) => {
      this.userService.lists.find((list) => list.id === item.listId).items.unshift(item);
      this.toastService.showToast('messages.lists.add');
    });
  }

  openNewListDialog() {
    const action: Action = {
      type: ActionType.ADD_TO_LIST,
      recordId: this.record.id,
    };

    this.doAction(() => {
      this.editListFacade.openDialog(undefined, this.record);
    }, action);
  }

  isRecordInList(listId: number) {
    return this.userService.isInList(listId, this.record.id);
  }
}
